export const emptyCodableTransaction: CMxCommonApp.CodableTransaction = {
  guid: '',
  sequence_number: 1,
  source_transaction_id: '',
  deleted: false,
  errorMessages: [],
  technical_code: null,
  procedure: null,
  mapped_procedure: null,
  modifiers: [],
  diagnoses: [],
  fee_schedule: '',
  place_of_service: '',
  codes: [],
  fieldDefinitions: []
};
